import {
  ADD_BUSINESS,
  ADD_BUSINESS_SUCCESS,
  ADD_BUSINESS_CLEAN,
  ADD_BUSINESS_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  business: {},
}

const BusinessAdd = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BUSINESS:
      state = {
        ...state,
        loading: true,
      }
      break
    case ADD_BUSINESS_SUCCESS:
      state = {
        ...state,
        business: action.payload.business,
        loading: false,
        done: true,
      }
      break
    case ADD_BUSINESS_CLEAN:
      state = initialState
      break
    case ADD_BUSINESS_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default BusinessAdd
